export function invalidChars(string, validChars) {
    if (!string) return [];
    const chars = [...new Set(string.toString().split(""))];
    const invalid = [];
    chars.forEach(char => {
        if (validChars.indexOf(char) === -1) {
            invalid.push(char);
        }
    });
    return invalid;
}

export function filterChars(string, validChars) {
    if (!string) return string;
    let output = string.toString();
    const chars = [...new Set(string.toString().split(""))];
    chars.forEach(char => {
        if (validChars.indexOf(char) === -1) {
            output = output.replace(char, "");
        }
    });
    return output;
}
